module.exports = __webpack_public_path__ + "img/red.89dea532.png";